/**
 * 日志工具类
 * 只有在非 production 环境，或者 localStorage 中 log 的值为 true 时，才允许输出日志
 */

/**
 * 检查是否允许输出日志
 * @returns {boolean} 是否允许输出日志
 */
function shouldLog(): boolean {
  // 检查环境：非 production 环境
  const isNotProduction = import.meta.env.MODE !== 'production';
  
  // 检查 localStorage 中 log 的值
  let localStorageLogEnabled = false;
  try {
    const logValue = localStorage.getItem('log');
    localStorageLogEnabled = logValue === 'true';
  } catch (e) {
    // localStorage 可能不可用（如隐私模式），忽略错误
  }
  
  // 只要满足任一条件即可输出日志
  return isNotProduction || localStorageLogEnabled;
}

/**
 * 日志工具对象
 */
const logger = {
  /**
   * 输出普通日志
   */
  log(...args: any[]): void {
    if (shouldLog()) {
      console.log(...args);
    }
  },

  /**
   * 输出信息日志
   */
  info(...args: any[]): void {
    if (shouldLog()) {
      console.info(...args);
    }
  },

  /**
   * 输出警告日志
   */
  warn(...args: any[]): void {
    if (shouldLog()) {
      console.warn(...args);
    }
  },

  /**
   * 输出错误日志
   */
  error(...args: any[]): void {
    if (shouldLog()) {
      console.error(...args);
    }
  },

  /**
   * 输出调试日志
   */
  debug(...args: any[]): void {
    if (shouldLog()) {
      console.debug(...args);
    }
  },

  /**
   * 输出表格日志
   */
  table(...args: any[]): void {
    if (shouldLog()) {
      console.table(...args);
    }
  },

  /**
   * 输出分组日志
   */
  group(...args: any[]): void {
    if (shouldLog()) {
      console.group(...args);
    }
  },

  /**
   * 结束分组日志
   */
  groupEnd(): void {
    if (shouldLog()) {
      console.groupEnd();
    }
  },

  /**
   * 输出分组折叠日志
   */
  groupCollapsed(...args: any[]): void {
    if (shouldLog()) {
      console.groupCollapsed(...args);
    }
  },

  /**
   * 输出时间日志
   */
  time(label?: string): void {
    if (shouldLog()) {
      console.time(label);
    }
  },

  /**
   * 结束时间日志
   */
  timeEnd(label?: string): void {
    if (shouldLog()) {
      console.timeEnd(label);
    }
  },
};

export default logger;


